var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlippboardTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 118,
    viewBox: "0 0 170 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 18)",
    fill: "#29B2EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 10)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_805_9521)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 70,
    rx: 30,
    ry: 10,
    fill: "#29B1EA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.9997 6.66675C84.0797 6.66675 83.333 7.41341 83.333 8.33341V11.6667H86.6663V8.33341C86.6663 7.41341 85.9197 6.66675 84.9997 6.66675Z",
    fill: "#184F85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9986 73.3334C94.2253 73.3334 93.5303 72.7917 93.367 72.0034L85.0003 31.5601L76.632 72.0051C76.4453 72.9067 75.557 73.4801 74.662 73.3001C73.7603 73.1134 73.1803 72.2301 73.367 71.3301L83.367 22.9967C83.5286 22.2217 84.2086 21.6667 85.0003 21.6667C85.792 21.6667 86.472 22.2217 86.632 22.9967L96.632 71.3301C96.817 72.2301 96.2386 73.1118 95.337 73.3001C95.2253 73.3218 95.1103 73.3334 94.9986 73.3334Z",
    fill: "url(#paint0_linear_805_9521)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.667 10H63.3337C62.4137 10 61.667 10.7467 61.667 11.6667V60C61.667 60.92 62.4137 61.6667 63.3337 61.6667H106.667C107.587 61.6667 108.334 60.92 108.334 60V11.6667C108.334 10.7467 107.587 10 106.667 10Z",
    fill: "#0078D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6335 11.6667C61.2852 35.2467 53.7518 49.2251 50.9952 53.5451C50.5918 54.1784 51.0468 55.0001 51.7985 55.0001H95.9152C96.4185 55.0001 96.8868 54.7751 97.2068 54.3867C99.4568 51.6567 107.985 39.4784 108.318 11.6667H61.6335Z",
    fill: "url(#paint1_linear_805_9521)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.333 10H61.6667C60.7467 10 60 10.7467 60 11.6667C60 12.5867 60.7467 13.3333 61.6667 13.3333H108.333C109.253 13.3333 110 12.5867 110 11.6667C110 10.7467 109.253 10 108.333 10Z",
    fill: "#50E6FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_805_9521",
    x: 31,
    y: 36,
    width: 108,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_805_9521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_805_9521",
    x1: 73.3336,
    y1: 47.5001,
    x2: 96.667,
    y2: 47.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#134575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_805_9521",
    x1: 79.5818,
    y1: 53.2467,
    x2: 79.5818,
    y2: 11.3717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33BEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A85D9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlippboardTile);
export default __webpack_public_path__ + "static/media/flippboardTile.a8a2549e92d05018264372e16fb4f1b3.svg";
export { ForwardRef as ReactComponent };